/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import { UserInteractionFields } from '../../entities';

export const updateFieldInteraction = createAction<UserInteractionFields>(
  'userInteraction/UPDATE_FIELD_INTERACTION',
);

export const updateVideoSoundPreference = createAction<boolean>(
  'userInteraction/UPDATE_VIDEO_SOUND_PREFERENCE',
);
